// Module
var code = "<div class=\"aspectratio\"> <div id=\"ytplayer\" class=\"embeddedplayer\"></div> </div>";
// Exports
module.exports = code;